export default "__VITE_ASSET__454970b3__"